"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var types_1 = require("@pbl/pbl-react-core/lib/models/ticket/types");
var AppSpinner_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/app-spinner/AppSpinner"));
var InteractiveGame_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/earn/v2/InteractiveGame"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = require("../../config/constants");
var actions_1 = require("../../redux/reducers/activity/actions");
var actions_2 = require("../../redux/reducers/app/actions");
var action_1 = require("../../redux/reducers/digital-game/action");
var actions_3 = require("../../redux/reducers/ledger/actions");
var action_2 = require("../../redux/reducers/prize-distribution/action");
var useActivityDetailsData_1 = require("../../shared/hooks/providers/useActivityDetailsData");
var useScrollToTop_1 = require("../../shared/hooks/useScrollToTop");
var framework_1 = require("../../widgets/framework");
var styles_1 = __importDefault(require("./styles"));
var getSpinResultsFromExtraData = function (extraData) {
    try {
        if (!!extraData) {
            var obj = JSON.parse(extraData);
            if (!!obj.spinResults) {
                return JSON.stringify(obj.spinResults);
            }
        }
    }
    catch (e) {
        return undefined;
    }
};
var InteractiveGameScreen = function (_a) {
    var _b, _c, _d;
    var classes = _a.classes, t = _a.t, identifier = _a.identifier, titleVariant = _a.titleVariant;
    var _e = (0, react_1.useState)(false), activityComplete = _e[0], setActivityCompleted = _e[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var theme = (0, core_1.useTheme)();
    var activityId = identifier + '';
    var _f = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), isLoggedIn = _f.isAuthenticated, authenticating = _f.authenticating, isRestricted = _f.isRestricted;
    var navigateToActivities = (0, react_1.useCallback)(function (message) {
        var appNavigate = {
            action: 'ACTIVITIES',
            data: message
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }, []);
    var redirectContactUs = function () {
        var appNavigate = {
            action: 'CONTACT_US'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var showInvalidError = (0, react_1.useCallback)(function () {
        navigateToActivities({
            message: t('activities.activityUnavailable'),
            type: 'warning',
            messageTimeout: 3000
        });
    }, [navigateToActivities, t]);
    var _g = (0, useActivityDetailsData_1.useActivityDetailsData)(activityId, isLoggedIn, showInvalidError), activity = _g.activity, initData = _g.initData;
    var _h = react_1.default.useState(false), gameCompleted = _h[0], setGameCompleted = _h[1];
    var _j = react_1.default.useState(false), refreshing = _j[0], setRefreshing = _j[1];
    var _k = react_1.default.useState(''), gameType = _k[0], setGameType = _k[1];
    var _l = react_1.default.useState(), digitalGameActivity = _l[0], setDigitalGameActivity = _l[1];
    var _m = react_1.default.useState(), gameConfig = _m[0], setGameConfig = _m[1];
    var _o = react_1.default.useState([]), prizes = _o[0], setPrizes = _o[1];
    var _p = react_1.default.useState(), multiplier = _p[0], setMultiplier = _p[1];
    var _q = react_1.default.useState(false), loading = _q[0], setLoading = _q[1];
    (0, useScrollToTop_1.useScrollToTop)();
    var showErrorMessage = function (error) {
        var _a, _b, _c;
        dispatch((0, actions_2.showMessageBar)({
            message: ((_b = (_a = error === null || error === void 0 ? void 0 : error.payload) === null || _a === void 0 ? void 0 : _a.detail) === null || _b === void 0 ? void 0 : _b.includes('invalidAccess'))
                ? t('error.activity.invalidAccess')
                : t((_c = error === null || error === void 0 ? void 0 : error.payload) === null || _c === void 0 ? void 0 : _c.errorKey),
            type: 'error'
        }));
    };
    var redirectToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
    };
    var getGameData = (0, react_1.useCallback)(function (type) { return __awaiter(void 0, void 0, void 0, function () {
        var data, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isLoggedIn) {
                        redirectToLogin();
                        return [2];
                    }
                    setRefreshing(true);
                    setGameType(type !== null && type !== void 0 ? type : 'prize');
                    data = [];
                    if (!activity) return [3, 5];
                    if (!(type === 'fun')) return [3, 2];
                    return [4, (0, action_1.playForFun)(activity.key, showErrorMessage)];
                case 1:
                    _a = _b.sent();
                    return [3, 4];
                case 2: return [4, (0, action_1.playForPoints)(activity.key, showErrorMessage)];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    data = _a;
                    _b.label = 5;
                case 5:
                    setPrizes(data !== null && data !== void 0 ? data : []);
                    setRefreshing(false);
                    return [2];
            }
        });
    }); }, [activity]);
    var getDigitalGameConfig = (0, react_1.useCallback)(function (token) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, (0, action_1.getGameConfig)(token)];
                case 1:
                    data = _a.sent();
                    if (data) {
                        if (data.face) {
                            data.face = JSON.parse(data.face);
                        }
                        setGameConfig(data);
                    }
                    return [2];
            }
        });
    }); }, []);
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, bonus_response, error_1, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(activity && ((_a = activity.frequencyCap) === null || _a === void 0 ? void 0 : _a.limitReached))) return [3, 8];
                        setLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        return [4, (0, action_2.getPrizeByExtraData)(activity.key)];
                    case 2:
                        response = _b.sent();
                        if (!response) return [3, 6];
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4, (0, actions_1.getBonusCampaign)(parseInt(response.externalId, 10))];
                    case 4:
                        bonus_response = _b.sent();
                        if (bonus_response) {
                            setMultiplier(bonus_response);
                        }
                        return [3, 6];
                    case 5:
                        error_1 = _b.sent();
                        console.error(error_1);
                        return [3, 6];
                    case 6: return [3, 8];
                    case 7:
                        error_2 = _b.sent();
                        console.error(error_2);
                        return [3, 8];
                    case 8:
                        setLoading(false);
                        return [2];
                }
            });
        }); };
        fetchData();
    }, [activity]);
    (0, react_1.useEffect)(function () {
        setRefreshing(true);
        if (prizes && prizes.length > 0) {
            getDigitalGameConfig(prizes[0].digitalRevealToken);
        }
        setRefreshing(false);
    }, [prizes, getDigitalGameConfig]);
    var getDigitalGame = (0, react_1.useCallback)(function (activityKey) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, (0, action_1.fetchDigitalGame)(activityKey, function (e) {
                        var _a, _b, _c;
                        dispatch((0, actions_2.showMessageBar)({
                            message: ((_b = (_a = e === null || e === void 0 ? void 0 : e.payload) === null || _a === void 0 ? void 0 : _a.detail) === null || _b === void 0 ? void 0 : _b.includes('invalidAccess'))
                                ? t('error.activity.invalidAccess')
                                : t((_c = e === null || e === void 0 ? void 0 : e.payload) === null || _c === void 0 ? void 0 : _c.errorKey),
                            type: 'error'
                        }));
                    })];
                case 1:
                    data = _a.sent();
                    if (data) {
                        setDigitalGameActivity(data);
                    }
                    return [2];
            }
        });
    }); }, []);
    (0, react_1.useEffect)(function () {
        if (activity) {
            getDigitalGame(activity.key);
        }
    }, [activity]);
    var gameEnded = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setRefreshing(true);
                    if (!gameCompleted) return [3, 4];
                    if (!(prizes && prizes.length > 0 && prizes[0].digitalRevealToken)) return [3, 4];
                    return [4, (0, action_1.endGame)(prizes[0].digitalRevealToken)];
                case 1:
                    _a.sent();
                    return [4, dispatch((0, actions_3.fetchUserPoints)())];
                case 2:
                    _a.sent();
                    return [4, initData()];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    setRefreshing(false);
                    return [2];
            }
        });
    }); };
    var onGameClose = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(prizes &&
                        prizes.length > 0 &&
                        prizes[0].digitalRevealToken &&
                        prizes[0].prizeType === types_1.PrizeType.BONUS_CAMPAIGN)) return [3, 4];
                    return [4, (0, action_1.endGame)(prizes[0].digitalRevealToken)];
                case 1:
                    _a.sent();
                    return [4, dispatch((0, actions_3.fetchUserPoints)())];
                case 2:
                    _a.sent();
                    return [4, initData()];
                case 3:
                    _a.sent();
                    return [3, 7];
                case 4: return [4, dispatch((0, actions_3.fetchUserPoints)())];
                case 5:
                    _a.sent();
                    return [4, initData()];
                case 6:
                    _a.sent();
                    _a.label = 7;
                case 7: return [2];
            }
        });
    }); };
    var setGameCompletedFunc = function () {
        framework_1.GoFwInternalInstance.onEarnActivity();
        setGameCompleted(true);
    };
    if (!activity) {
        return null;
    }
    var interactiveGameConfig = gameConfig === null || gameConfig === void 0 ? void 0 : gameConfig.gameConfig;
    var spinResults;
    var gamePoints = prizes && prizes.length > 0 ? prizes[0].baseAmount : 0;
    if (gameConfig && gameConfig.face) {
        spinResults = getSpinResultsFromExtraData(gameConfig.face);
    }
    var onDismissEarnPointsModal = function () {
        var _a;
        if ((_a = activity === null || activity === void 0 ? void 0 : activity.frequencyCap) === null || _a === void 0 ? void 0 : _a.limitReached) {
            navigateToActivities();
        }
        else {
            setActivityCompleted(false);
        }
    };
    if (!activity) {
        return null;
    }
    return (react_1.default.createElement("div", { className: classes.container },
        activityComplete && (react_1.default.createElement(package_1.EarnPointsModal, { pointEarned: activity.amount + ((_b = activity.bonusAmount) !== null && _b !== void 0 ? _b : 0), isVisible: activityComplete, onClose: onDismissEarnPointsModal })),
        react_1.default.createElement(Grid_1.default, { className: classes.container, container: true, spacing: 2 }, loading ? (react_1.default.createElement(AppSpinner_1.default, { label: t('loading') })) : (react_1.default.createElement(InteractiveGame_1.default, { getGameData: getGameData, renderTitle: function () { return (react_1.default.createElement(core_1.Typography, { variant: titleVariant !== null && titleVariant !== void 0 ? titleVariant : 'h2' }, activity.title)); }, selectedUserActivity: activity, playForFun: digitalGameActivity === null || digitalGameActivity === void 0 ? void 0 : digitalGameActivity.playForFun, digitalRevealTokenDetails: gameConfig, numPoints: activity.amount, limitReached: activity.frequencyCap ? activity.frequencyCap.limitReached : false, refreshing: refreshing, gameFace: gameConfig === null || gameConfig === void 0 ? void 0 : gameConfig.face, gameConfig: interactiveGameConfig, gameUrl: (_c = gameConfig === null || gameConfig === void 0 ? void 0 : gameConfig.themeHostName) !== null && _c !== void 0 ? _c : '', gamePoints: gamePoints, spinResults: spinResults, gameType: gameType, onGameExitHandler: gameEnded, onGameEndHandler: setGameCompletedFunc, portraitMode: ((_d = activity.extraData['portraitMode']) === null || _d === void 0 ? void 0 : _d.value.toLowerCase()) === 'true', isLoggedIn: isLoggedIn, onClose: onGameClose, multiplier: multiplier, isRestricted: isRestricted && isLoggedIn, handleContactUs: redirectContactUs, showSignInWarning: !isLoggedIn && constants_1.RemoteConstants.getBoolean('SHOW_SIGN_IN_WARNING'), redirectToLogin: redirectToLogin })))));
};
exports.default = (0, react_i18next_1.withTranslation)()((0, core_1.withStyles)(styles_1.default)(InteractiveGameScreen));
//# sourceMappingURL=index.js.map